import { render } from "./__Footer.vue?vue&type=template&id=1e89fc84&scoped=true"
import script from "./__Footer.vue?vue&type=script&lang=js"
export * from "./__Footer.vue?vue&type=script&lang=js"

import "./__Footer.vue?vue&type=style&index=0&id=1e89fc84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e89fc84"]])

export default __exports__